import {Power2, TimelineMax, TweenMax, gsap} from "gsap";
import {init} from "../utils/_livesearch";

const settings = {
    modalSelector: '[js-search-modal]',
    searchBarSelector: '[js-search]',
    openSelector: '[js-search-open]',
    openAttribute: 'js-search-open',
    closeSelector: '[js-search-close]',
    openClass: 'open',
    hideClass: 'hide',
    formSelector: '[js-search-form]',
    inputSelector: '[js-search-input]',
    searchPageForm: '[js-main-search-form]',
    searchResultCount: '[js-search-count]',
    searchQuery: '[js-search-query]',
    searchTitle: '[js-search-title]',
    breadcrumbSearch: '.breadcrumb_last'
}

const modal = document.querySelector(settings.modalSelector);
const openSelectors = document.querySelectorAll(settings.openSelector);
const closeSelectors = document.querySelectorAll(settings.closeSelector);

const forms = document.querySelectorAll(settings.formSelector);
const searchPageForm = document.querySelector(settings.searchPageForm);

const tweenModal = new TimelineMax({paused: true})
    .add([
        TweenMax.fromTo(".gsap-modal", .2, {translateY: "-150%", ease:Power2.easeOut}, {translateY: 0, ease:Power2.easeOut}),
        TweenMax.fromTo(".gsap-text", gsap.utils.random(0.1, 0.3), {translateY: 10, opacity: 0, ease:Power2.easeOut}, {translateY: 0, opacity: 1, ease:Power2.easeOut, delay: .2}),
    ]);

if (modal) {
    openSelectors.forEach(selector => {
        selector.addEventListener('click', () => {
            tweenModal.play();
            modal.querySelector(settings.inputSelector).focus();
            document.body.classList.add("search-open");
        });
    });

    closeSelectors.forEach(selector => {
        selector.addEventListener('click', () => {
            tweenModal.reverse();
            document.body.classList.remove("search-open");
        });
    });
}

if (forms) {
    forms.forEach(form => {
        form.addEventListener('submit', e => {
            const input = form.querySelector(settings.inputSelector);

            if (input.value.length === 0) {
                e.preventDefault();
                return false;
            }
        })
    })
}

if (searchPageForm) {
    /**
     * Init Livesearch
     * @type {*}
     */
    const livesearch = init({
        perPage: 5
    });

    const title = document.querySelector(settings.searchTitle);
    const searchQuery = document.querySelector(settings.searchQuery);
    const resultCounter = document.querySelector(settings.searchResultCount);
    const breadcrumb = document.querySelector(settings.breadcrumbSearch);

    livesearch.on('afterChange', (response) => {
        const query = response.params.s ? response.params.s : "";
        searchQuery.innerHTML = "Les résultats de recherche pour « " + query + " »";
        resultCounter.innerHTML = "(" + response.results.all_total + ")";
        breadcrumb.innerHTML = "Résultats de recherche pour " + query;

        if (response.results.all_total === 0) {
            title.classList.add(settings.hideClass);
        } else {
            if (title.classList.contains(settings.hideClass)) {
                title.classList.remove(settings.hideClass)
            }
        }
    });
}
